module.exports = __webpack_public_path__ + "img/Group-blank.c00cebf8.svg";